import React, { useState, useEffect } from 'react'
import {
  Panel,
  Form,
  Button,
  Message,
  ControlLabel,
  DatePicker,
  Row,
  Col,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Uploader,
  Icon,
  IconButton,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import InputForm from '../../../components/forms/input/InputForm'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import {
  updateSubprojectWithdrawRequest,
  downloadSubprojectWithdrawAttachment,
} from '../../../redux/actions/withdrawRequest'
import pathname from '../../../constants/pathname'
import PeriodExpensesSubproject from '../../../widgets/budget/periodExpenses/PeriodExpensesSubproject'
import moment from 'moment'
import classNames from 'classnames'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { DATE_FORMAT, LOCAL_DAY_TH, DD_MM_YYYY_SLASH } from '../../../constants/date'
import {
  isValidators,
  isRequired,
  getMaxLengthData,
  requiredFiled,
  isImageOrPdf,
} from '../../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'
import AppContext from '../../../context/AppContext'
import NumberFormat from 'react-number-format'
import Whisper from 'rsuite'
import notification from '../../../utils/notification'

export default function WithdrawRequestSubWidget({
  schema: _schema,
  isEditable,
  isHidePeriodExpenses,
  isHideBudgetPlan,
  isCollapseAllTableRow,
  isEditableBudgetPlan,
  isShowBudgetSubmitButton,
  shouldGetSidebarAfterSaveBudgetPlan,
  projectVersionId,
  onClickConfirmBudget = () => {},
  disabled,
  ...props
}) {
  const { theme } = React.useContext(AppContext)

  const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [requestId, setRequestId] = useState('')
  const [planStatusCode, setPlanStatusCode] = useState(_schema?.requestNote?.planStatus.value)
  const [dataTable, setDataTable] = useState([])
  const [withdrawAmount, setWithdrawAmount] = useState([])
  const [attachFileId, setAttachFileId] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  // console.log('ssssssssssssssssssssssssss', formSchema)
  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  useEffect(() => {
    // let requestId = location.search.substring(1)
    let requestId = sessionStorage.getItem('param')?.substring(1)
    console.log('WithdrawRequestWidget', 'request_id: ', requestId)
    if (requestId) {
      setRequestId(requestId)
    }
  }, [location.search])

  useEffect(() => {
    console.log('_schema', _schema)
    if (_schema.budgetInfo) {
      const _data = [{ ..._schema.budgetInfo, list: _schema.requestNote.header }]
      setDataTable(_data)

      console.log('_data', _data)

      //generate data for post without edit
      let _withdrawAmount = []
      if (_data.length > 0) {
        _data.forEach((element) => {
          element.children.forEach((element2) => {
            element2.children.forEach((item) => {
              console.log('item', item)
              _withdrawAmount.push({
                WithdrawAmount: item?.withdrawAmount?.value || item.installmentAmount || 0,
                WithdrawByCateId: item.withdrawByCateId,
              })
            })
          })
        })
      }
      setWithdrawAmount(_withdrawAmount)
      setValue('withdrawAmount', _withdrawAmount)
    }
  }, [_schema])

  const handleGetDownloadAttachFile = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await downloadSubprojectWithdrawAttachment(
        projectId,
        requestId,
        formSchema?.withdrawFiles[0]?.id || ''
      )
      console.log('response preview pdf', response)
      if (response) {
        onDownloadAttachFile(response)
      } else {
        setIsError('ดาวน์โหลดไม่สำเร็จ no response')
      }
    } catch (e) {
      setIsError('ดาวน์โหลดไม่สำเร็จ ' + e?.data?.response)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownloadAttachFile = async (fileObj) => {
    startLoading()
    try {
      var file = fileObj

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'รายงานการเบิกจ่าย')
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: 'ดาวน์โหลดไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleCallService = async (request) => {
    const file = request[formSchema?.requestNote?.attachments?.name]
    var formData = new FormData()
    console.log('withdrawAmount', withdrawAmount)
    file?.forEach((element) => {
      formData.append('WithdrawFiles', element.blobFile)
    })

    formData.append('WithdrawDate', request.withdrawDate.toISOString() || '')
    formData.append('Note', request.note || '')
    formData.append('PlanStatus', request.planStatus === 1 ? true : false || false)
    formData.append('PlanStatusReason', request.planStatusReason || '')
    formData.append('IsDelivered', request.isDelivered || false)
    formData.append('WithdrawByCateItemString', JSON.stringify(withdrawAmount) || '')

    // withdrawAmount?.forEach((element) => {
    //   formData.append('withdrawByCateId', element.WithdrawByCateId)
    // })

    // withdrawAmount?.forEach((element) => {
    //   formData.append('withdrawAmount', element.WithdrawAmount)
    // })

    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await updateSubprojectWithdrawRequest(projectId, requestId, formData)

      console.log('response', response)

      if (response.success) {
        setIsLoading(false)
        doneLoading()
        setIsError(false)
        setIsShowConfirm(false)
        return history.push(`${pathname.subProject.overviewSubProject}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      }
    }
    setIsLoading(false)
    doneLoading()
    setIsShowConfirm(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = { ...data }
    setRequest(request)

    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)

    handleCallService(request)
    //setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }
  const handleOnChangeBudget = (totalInstallment) => {
    setCurrentTotalInstallment(totalInstallment)
    setIsEditBudgetPlan(true)
  }

  const handleOnWithdrawAmountChange = (rowData, value) => {
    if (rowData.withdrawAmount) {
      let list = [...withdrawAmount]
      let isInList = false
      if (list.length > 0) {
        list.forEach((item, index) => {
          if (item.WithdrawByCateId === rowData.withdrawByCateId) {
            let data = {
              WithdrawByCateId: rowData.withdrawByCateId,
              WithdrawAmount: value,
            }
            list.splice(index, 1, data)
            isInList = true
          }
        })
      }

      if (!isInList) {
        let data = {
          WithdrawByCateId: rowData.withdrawByCateId,
          WithdrawAmount: value,
        }
        list.push(data)
      }
      setWithdrawAmount(list)
      setValue('withdrawAmount', list)
    }
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <div style={{ marginBottom: 10 }}>
        {/* <PeriodExpensesSubproject
          header={formSchema.budget?.periodExpensesHeader}
          data={formSchema.budget?.periodExpensesData}
          initialInstallment={formSchema.masterCategoryOfCost}
          initialData={formSchema.masterCategoryCost}
          startProjectDate={formSchema.budget?.startProjectDate}
          endProjectDate={formSchema.budget?.endProjectDate}
          isEditable={isEditable}
          isCollapseAllTableRow={isCollapseAllTableRow}
          projectVersionId={projectVersionId}
          onChangeBudget={handleOnChangeBudget}
        /> */}
        <PeriodExpensesSubproject
          header={formSchema.budgetInfo?.periodExpensesHeader || 'ขอเบิกงวดเงิน'}
          data={dataTable}
          initialInstallment={formSchema.masterCategoryOfCost}
          initialData={formSchema.masterCategoryCost}
          startProjectDate={formSchema.budgetInfo?.startProjectDate}
          endProjectDate={formSchema.budgetInfo?.endProjectDate}
          isEditable={isEditable}
          isCollapseAllTableRow={isCollapseAllTableRow}
          projectVersionId={projectVersionId}
          onChangeBudget={handleOnChangeBudget}
          widgetControl={control}
          widgetErrors={errors}
          onWithdrawAmountChange={(rowData, value) => handleOnWithdrawAmountChange(rowData, value)}
          isWithdrawRequestSub={true}
          disabledForm={disabled}
        />
      </div>

      {formSchema.requestNote && (
        <Row>
          <Col xs={24} sm={15} md={12} lg={6} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(formSchema.requestNote.withdrawDate.validators) && 'required'
              )}
            >
              {formSchema.requestNote.withdrawDate.label}
            </ControlLabel>
            <ErrorMessage error={errors.withdrawDate} />
            <Controller
              name={formSchema.requestNote.withdrawDate.name}
              control={control}
              defaultValue={
                formSchema.requestNote.withdrawDate.value
                  ? moment(formSchema.requestNote.withdrawDate.value, DD_MM_YYYY_SLASH).toDate()
                  : null
              }
              rules={isValidators(formSchema.requestNote.withdrawDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    placement="auto"
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                    disabled={disabled}
                  />
                )
              }}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
            <InputForm
              schema={formSchema.requestNote?.note}
              // rows={3}
              // componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              disabled={disabled}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
            <Controller
              key={formSchema.requestNote.planStatus.name}
              name={formSchema.requestNote.planStatus.name}
              defaultValue={planStatusCode}
              control={control}
              render={(props) => {
                return (
                  <RadioGroup
                    name={formSchema.requestNote.planStatus.name}
                    inline
                    defaultValue={formSchema.requestNote.planStatus.value}
                    onChange={(value) => {
                      props.onChange(value)
                      setPlanStatusCode(value)
                    }}
                  >
                    {formSchema.requestNote.planStatus.options?.map((item) => {
                      return (
                        <Radio value={item.value} disabled={disabled}>
                          {item.label}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />

            {planStatusCode === 0 && (
              <InputForm
                schema={formSchema.requestNote?.planStatusReason}
                rows={3}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                disabled={disabled}
              />
            )}
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
            <ErrorMessage error={errors.isDelivered} />
            <Controller
              key={formSchema.requestNote?.isDelivered.name}
              name={formSchema.requestNote?.isDelivered.name}
              defaultValue={formSchema.requestNote?.isDelivered.value}
              control={control}
              rules={isValidators(formSchema.requestNote?.isDelivered?.validators)}
              render={(props) => {
                return (
                  <Checkbox
                    checked={props.defaultValue}
                    onChange={(value, checked) => {
                      props.onChange(checked)
                      // setPlanStatusCode(value)
                    }}
                    disabled={disabled}
                  >
                    <span className={'required'}>{formSchema.requestNote?.isDelivered?.label}</span>
                  </Checkbox>
                )
              }}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                isRequired(formSchema?.requestNote?.attachments?.validators) && 'required'
              )}
            >
              {formSchema.requestNote.attachments.label}
            </ControlLabel>
            <ErrorMessage error={errors.attachments} />
            <Controller
              name={formSchema.requestNote.attachments.name}
              control={control}
              defaultValue={
                !isEmpty(formSchema.requestNote.attachments.value)
                  ? [formSchema.requestNote.attachments.value]
                  : undefined
              }
              rules={isValidators(formSchema.requestNote.attachments.validators)}
              render={(props) => {
                return (
                  <Uploader
                    draggable
                    autoUpload={false}
                    fileList={props.value || []}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let files = []
                        files.push(fileList[fileList.length - 1])
                        props.onChange(files)
                      }
                    }}
                    disabled={disabled}
                  >
                    <div>
                      <div
                        style={{ lineHeight: '50px' }}
                        className={classNames('uploader', `${theme[0]}-background`)}
                      >
                        <Icon size="4x" icon="upload2" />
                        <small className="uploder__text">
                          <p style={{ wordBreak: 'break-word' }}>
                            คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                          </p>
                        </small>
                      </div>
                    </div>
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>
      )}

      {isError && <Message showIcon type="error" description={isError} />}

      {formSchema?.withdrawFiles?.length > 0 && formSchema?.withdrawFiles[0]?.id && (
        <IconButton
          appearance="ghost"
          icon={<Icon icon="download" className="bt-gost-icon-radius"></Icon>}
          onClick={handleGetDownloadAttachFile}
        >
          {'ดาวน์โหลดเอกสารที่แนบแล้ว'}
        </IconButton>
      )}
      <hr />
      <Button ripple appearance="ghost" onClick={handleSubmit(onSubmit)} disabled={disabled}>
        {formSchema?.withdrawRequest?.buttonText || 'ขอเบิกงวดเงิน'}
      </Button>
      <ConfirmWidget
        title={`ยืนยันการ${formSchema?.withdrawRequest?.buttonText || 'ขอเบิกงวดเงิน'}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema?.withdrawRequest?.buttonText || 'ขอเบิกงวดเงิน'}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
